import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../api/axios";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

function CommunityCenterList() {
const navigate = useNavigate();
    const [centers, setCenters] = useState([]);
    const [loading, setLoading] = useState(true);
const menus = JSON.parse(localStorage.getItem("menus") || "[]");

    const location = useLocation();
    
    const currentMenu = menus.find(
      x => x.menuUrl?.toLowerCase() === location.pathname.toLowerCase()
    );
    
    
    const currentMenuId = currentMenu?.menuId;
    
    
    const hasAction = (menuId, actionCode) => {
      const menu = menus.find(
        x => Number(x.menuId) === Number(menuId)
      );
    
      return menu?.actions?.some(
        x => x.actionCode === actionCode
      ) ?? false;
    };


    const loadCommunityCenters = async () => {

        try {

            setLoading(true);

            const response =
                await api.get("/CommunityCenter/GetAll");

            setCenters(response.data || []);

        } catch (error) {

            console.error(error);

            Swal.fire(
                "Error",
                "Community Center data load nahi ho saka",
                "error"
            );

        } finally {

            setLoading(false);
        }
    };


    useEffect(() => {

        loadCommunityCenters();

    }, []);


    // ============================
    // IMAGE URL
    // ============================

    const getFileUrl = (path) => {

        if (!path)
            return null;

        if (path.startsWith("http"))
            return path;

        return `${api.defaults.baseURL?.replace("/api", "")}${path}`;
    };


    // ============================
    // DELETE
    // ============================

    const handleDelete = async (id) => {

        const result = await Swal.fire({

            title: "Are you sure?",

            text: "Community Center delete ho jayega.",

            icon: "warning",

            showCancelButton: true,

            confirmButtonText: "Yes, Delete",

            cancelButtonText: "Cancel"
        });


        if (!result.isConfirmed)
            return;


        try {

            await api.delete(
                `/CommunityCenter/Delete/${id}`
            );

            Swal.fire(
                "Deleted!",
                "Community Center deleted successfully",
                "success"
            );

            loadCommunityCenters();

        } catch (error) {

            console.error(error);

            Swal.fire(
                "Error",
                "Delete nahi ho saka",
                "error"
            );
        }
    };


    // ============================
    // STATUS
    // ============================

    const handleStatus = async (item) => {

        try {

            const userId =
                localStorage.getItem("userId");

            await api.put(
                `/CommunityCenter/ToggleStatus/${item.communityCenterId}`,
                userId
            );

            Swal.fire(
                "Success",
                "Status updated successfully",
                "success"
            );

            loadCommunityCenters();

        } catch (error) {

            console.error(error);

            Swal.fire(
                "Error",
                "Status update nahi ho saka",
                "error"
            );
        }
    };


    // ============================
    // LOADING
    // ============================

    if (loading) {

        return (
            <div className="text-center p-5">

                <div
                    className="spinner-border text-primary"
                    role="status"
                />

                <div className="mt-2">
                    Loading Community Centers...
                </div>

            </div>
        );
    }


    return (

        <div className="container-fluid py-3">

            <div className="card shadow-sm">

                {/* HEADER */}

                {/* <div className="card-header d-flex justify-content-between align-items-center"> */}
<div class="card-header bg-primary text-white">
                    <h4 className="mb-0">
                        Community Center List
                    </h4>

                    <span className="badge bg-primary">
                        Total: {centers.length}
                    </span>

                </div>


                {/* BODY */}

                <div className="card-body p-0">

                    <div className="table-responsive">

                        <table className="table table-bordered table-hover align-middle mb-0">

                            <thead className="table-light">

                                <tr>

                                    <th>
                                        #
                                    </th>

                                    <th>
                                        Image
                                    </th>

                                    <th>
                                        Community Center
                                    </th>

                                    <th>
                                        Location
                                    </th>

                                    <th>
                                        Latitude
                                    </th>

                                    <th>
                                        Longitude
                                    </th>

                                    <th>
                                        Area
                                    </th>

                                    <th>
                                        Rate / Day
                                    </th>

                                    <th>
                                        Cleaning
                                    </th>

                                    <th>
                                        Security
                                    </th>

                                    <th>
                                        GST
                                    </th>

                                    <th>
                                        Total
                                    </th>

                                    <th>
                                        Contact
                                    </th>

                                    <th>
                                        Capacity
                                    </th>

                                    <th>
                                        Facilities
                                    </th>

                                    <th>
                                        Status
                                    </th>

                                    <th>
                                        Created Date
                                    </th>

                                    <th>
                                        Action
                                    </th>

                                </tr>

                            </thead>


                            <tbody>

                                {centers.length === 0 ? (

                                    <tr>

                                        <td
                                            colSpan="18"
                                            className="text-center py-4"
                                        >
                                            No Community Center found
                                        </td>

                                    </tr>

                                ) : (

                                    centers.map((item, index) => (

                                        <tr key={
                                            item.communityCenterId
                                        }>

                                            {/* # */}

                                            <td>
                                                {index + 1}
                                            </td>


                                            {/* IMAGE */}

                                            <td>

                                                {item.ccImage ? (

                                                    <img
                                                        src={getFileUrl(
                                                            item.ccImage
                                                        )}
                                                        alt={
                                                            item.communityCenterName
                                                        }
                                                        style={{
                                                            width: "80px",
                                                            height: "60px",
                                                            objectFit: "cover",
                                                            borderRadius: "6px"
                                                        }}
                                                    />

                                                ) : (

                                                    <span className="text-muted">
                                                        No Image
                                                    </span>

                                                )}

                                            </td>


                                            {/* NAME */}

                                            <td>

                                                <strong>
                                                    {
                                                        item.communityCenterName
                                                    }
                                                </strong>

                                                <br />

                                                <small className="text-muted">
                                                    ID: {
                                                        item.communityCenterId
                                                    }
                                                </small>

                                            </td>


                                            {/* LOCATION */}

                                            <td>

                                                {item.communityCenterLocation}

                                                <br />

                                                <small className="text-muted">

                                                    {item.address}

                                                </small>

                                            </td>


                                            {/* LATITUDE */}

                                            <td>
                                                {item.latitude}
                                            </td>


                                            {/* LONGITUDE */}

                                            <td>
                                                {item.longitude}
                                            </td>


                                            {/* AREA */}

                                            <td>
                                                {item.areaPerAcre} Acre
                                            </td>


                                            {/* RATE */}

                                            <td>
                                                ₹ {Number(
                                                    item.ratePerDay
                                                ).toFixed(2)}
                                            </td>


                                            {/* CLEANING */}

                                            <td>
                                                ₹ {Number(
                                                    item.cleaningCharges
                                                ).toFixed(2)}
                                            </td>


                                            {/* SECURITY */}

                                            <td>
                                                ₹ {Number(
                                                    item.securityCharges
                                                ).toFixed(2)}
                                            </td>


                                            {/* GST */}

                                            <td>

                                                {item.gstPercentage}%

                                                <br />

                                                <small>
                                                    ₹ {Number(
                                                        item.gstAmount
                                                    ).toFixed(2)}
                                                </small>

                                            </td>


                                            {/* TOTAL */}

                                            <td>

                                                <strong>
                                                    ₹ {Number(
                                                        item.totalAmount
                                                    ).toFixed(2)}
                                                </strong>

                                            </td>


                                            {/* CONTACT */}

                                            <td>

                                                {item.contactPerson}

                                                <br />

                                                <small>
                                                    {item.contactNumber}
                                                </small>

                                            </td>


                                            {/* CAPACITY */}

                                            <td>

                                                {item.capacity
                                                    ? `${item.capacity} Persons`
                                                    : "-"
                                                }

                                            </td>


                                            {/* FACILITIES */}

                                            <td>

                                                {item.facilities || "-"}

                                            </td>


                                            {/* STATUS */}

                                            <td>

                                                <button
                                                    type="button"
                                                    className={
                                                        item.isActive
                                                            ? "btn btn-sm btn-success"
                                                            : "btn btn-sm btn-secondary"
                                                    }
                                                    onClick={() =>
                                                        handleStatus(item)
                                                    }
                                                >

                                                    {item.isActive
                                                        ? "Active"
                                                        : "Inactive"
                                                    }

                                                </button>

                                            </td>


                                            {/* CREATED DATE */}

                                            <td>

                                                {item.createdDate
                                                    ? new Date(
                                                        item.createdDate
                                                    ).toLocaleDateString(
                                                        "en-GB"
                                                    )
                                                    : "-"
                                                }

                                            </td>


                                            {/* ACTION
                                            
                                            {item.ccVideo && (
    <video
        width="100"
        height="60"
        controls
        style={{
            objectFit: "cover",
            marginTop: "5px"
        }}
    >
        <source
            src={getFileUrl(item.ccVideo)}
            type="video/mp4"
        />
    </video>
)}
                                            
                                            */}

                                            <td>

                                                <div className="d-flex gap-1 justify-content-center">

                                                    {/* <button
                                                        type="button"
                                                        className="btn btn-sm btn-primary"
                                                        title="Edit"
                                                    >
                                                        <i className="bi bi-pencil"></i>
                                                    </button> */}

<button
    type="button"
    className="btn btn-sm btn-outline-primary"
    title="Edit"
    onClick={() =>
        navigate(
            `/EditCommunityCenter/${item.communityCenterId}`
        )
    }
>
    <i className="bi bi-pencil"></i>
</button>

                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-danger"
                                                        title="Delete"
                                                        onClick={() =>
                                                            handleDelete(
                                                                item.communityCenterId
                                                            )
                                                        }
                                                    >
                                                        <i className="bi bi-trash"></i>
                                                    </button>


                                                    <button
    type="button"
    className="btn btn-success"
    onClick={() =>
        navigate(
            `/CommunityCenterBooking/${item.communityCenterId}`
        )
    }
>
    <i className="bi bi-calendar-check me-1"></i>
    Book Now
</button>


                                                </div>

                                                {hasAction(currentMenuId, "ADD") && (
  <button>Add</button>
)}

{hasAction(currentMenuId, "EDIT") && (
  <button>Edit</button>
)}

{hasAction(currentMenuId, "DELETE") && (
  <button>Delete</button>
)}


                                            </td>

                                        </tr>

                                    ))

                                )}

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

        </div>
    );
}

export default CommunityCenterList;